export const environment = {
  production: false,
  BFF_URL: 'https://capp-sbcheckout-bff-hml.grayfield-7ea88d36.eastus2.azurecontainerapps.io/bff/*/checkout',
  TRANSACTION_API_URL: 'https://capp-sbcheckout-bff-hml.grayfield-7ea88d36.eastus2.azurecontainerapps.io/bff/*/transactions',
  DOWNLOAD_DOCUMENT_URL: 'https://capp-sbcheckout-bff-hml.grayfield-7ea88d36.eastus2.azurecontainerapps.io',
};
